var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFailure(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 192,
    height: 131,
    viewBox: "0 0 192 131",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#DFDFDF",
    d: "M29 8.544c11.28 0 20.457 9.176 20.457 20.456S40.28 49.456 29 49.456C17.72 49.456 8.543 40.28 8.543 29S17.72 8.544 29 8.544M29 0C12.983 0 0 12.984 0 29c0 16.017 12.983 29 29 29s29-12.984 29-29S45.016 0 29 0z",
    transform: "translate(-757 -534) translate(757 534)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#E5E8ED",
    d: "M187.71 42H71.29C68.92 42 67 39.985 67 37.5s1.92-4.5 4.29-4.5h116.42c2.37 0 4.29 2.015 4.29 4.5s-1.92 4.5-4.29 4.5zM130.72 23H71.28C68.916 23 67 20.985 67 18.5s1.916-4.5 4.28-4.5h59.44c2.364 0 4.28 2.015 4.28 4.5 0 2.486-1.917 4.5-4.28 4.5zM187.71 116H71.29c-2.37 0-4.29-2.015-4.29-4.5s1.92-4.5 4.29-4.5h116.42c2.37 0 4.29 2.015 4.29 4.5s-1.92 4.5-4.29 4.5zM130.72 96H71.28C68.916 96 67 93.985 67 91.5s1.916-4.5 4.28-4.5h59.44c2.364 0 4.28 2.015 4.28 4.5s-1.917 4.5-4.28 4.5z",
    transform: "translate(-757 -534) translate(757 534)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#F15F28",
    d: "M31 81.544c11.28 0 20.457 9.176 20.457 20.456S42.28 122.456 31 122.456c-11.28 0-20.457-9.176-20.457-20.456S19.72 81.544 31 81.544M31 73C14.984 73 2 85.984 2 102s12.984 29 29 29c16.017 0 29-12.984 29-29S47.017 73 31 73z",
    transform: "translate(-757 -534) translate(757 534)"
  }), /*#__PURE__*/React.createElement("g", {
    fill: "#F15F28"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M21.376 24.8c-.884 0-1.767-.338-2.441-1.012L1.39 6.244C.043 4.895.043 2.709 1.391 1.36 2.74.012 4.925.012 6.274 1.36l17.543 17.544c1.349 1.349 1.349 3.535 0 4.883-.674.674-1.558 1.012-2.441 1.012z",
    transform: "translate(-757 -534) translate(757 534) translate(18 91)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.832 24.8c-.884 0-1.767-.338-2.441-1.012-1.349-1.348-1.349-3.534 0-4.883L18.934 1.36c1.349-1.349 3.534-1.349 4.883 0 1.348 1.348 1.348 3.534 0 4.883L6.273 23.788c-.674.674-1.557 1.012-2.441 1.012z",
    transform: "translate(-757 -534) translate(757 534) translate(18 91)"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#DFDFDF",
    d: "M26.074 40c-.738 0-1.48-.244-2.101-.746l-6.684-5.393c-1.47-1.185-1.72-3.362-.558-4.862 1.161-1.5 3.294-1.755 4.763-.57l4.115 3.32 10.414-12.527c1.212-1.458 3.352-1.637 4.78-.4 1.428 1.237 1.603 3.422.392 4.88L28.66 38.778c-.669.805-1.624 1.222-2.587 1.222z",
    transform: "translate(-757 -534) translate(757 534)"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFailure);
export default __webpack_public_path__ + "static/media/failure.1a5dd67be2e62a1508719d6958048761.svg";
export { ForwardRef as ReactComponent };